import { z } from 'zod';

/**
 * ApprovalRules — PYLON-2A-APPROVAL-WORKFLOW
 *
 * Rule-engine types for dock booking pre-flight validation.
 * Three rule types: dock_type check, hazmat_clearance check, trailer_fit check.
 * Patent gate: F-PYLON-APPROVAL-GATE-001
 */

// ── Constants ────────────────────────────────────────────────────────────────

export const DOCK_TYPES = Object.freeze({
  STANDARD:    'standard',
  REFRIGERATED: 'refrigerated',
  HAZMAT:      'hazmat',
  OVERSIZED:   'oversized',
});

export const HAZMAT_LEVELS = Object.freeze({
  NONE:       'none',
  CLASS_3:    'class_3',
  CLASS_8:    'class_8',
  RESTRICTED: 'restricted',
});

// ── ApprovalRuleSchema ────────────────────────────────────────────────────────

const DockTypeRuleSchema = z.object({
  ruleType:         z.literal('dock_type'),
  allowedDockTypes: z.array(z.string()).min(1),
});

const HazmatClearanceRuleSchema = z.object({
  ruleType:        z.literal('hazmat_clearance'),
  maxHazmatLevel:  z.enum(['none', 'class_3', 'class_8', 'restricted']),
});

const TrailerFitRuleSchema = z.object({
  ruleType:          z.literal('trailer_fit'),
  maxTrailerLength:  z.number().positive(),
});

export const ApprovalRuleSchema = z.object({
  id:         z.string().optional(),
  tenantId:   z.string(),
  isDeleted:  z.boolean().default(false),
  condition:  z.discriminatedUnion('ruleType', [
    DockTypeRuleSchema,
    HazmatClearanceRuleSchema,
    TrailerFitRuleSchema,
  ]).optional(),
}).passthrough();

// ── ApprovalViolationSchema ───────────────────────────────────────────────────

export const ApprovalViolationSchema = z.object({
  ruleId:   z.string(),
  ruleType: z.string(),
  reason:   z.string(),
}).passthrough();

// ── ApprovalResultSchema ──────────────────────────────────────────────────────

export const ApprovalResultSchema = z.object({
  isValid:      z.boolean(),
  violations:   z.array(ApprovalViolationSchema),
  validatedAt:  z.string(),
}).passthrough();
